module.exports = __webpack_public_path__ + "prod/1.42.2/img/personnel-three.1414abb5.png";